import React, { useState, useEffect } from "react";
import { Tabs, Tab, Theme, Typography, Icon } from "@material-ui/core";
import { navigate } from "@reach/router";
import { makeStyles } from "@material-ui/styles";
import { BackofficeApplicationResource } from "../../../../resources";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
	tabs: {
		borderRight: `1px solid ${theme.palette.secondary.main}`,
	},
	tabItem: {
		whiteSpace: "pre",
	},
	objectIcon: {
		width: "100%",
		height: "100%",
	},
}));
const findIndex = (id: number, data: BackofficeApplicationResource[]) => {
	let idx: boolean | number = false;
	data.forEach((element, i) => {
		if (id === element.id) {
			idx = i;
		}
	});
	return idx;
};

interface BackofficeApplicationListProps {
	data: BackofficeApplicationResource[];
	closeMenuDrawer: () => void;
}
export const BackofficeApplicationList = (
	props: BackofficeApplicationListProps
) => {
	const { data, closeMenuDrawer } = props;
	const classes = useStyles();

	const [value, setValue] = useState(false);
	useEffect(() => {
		setValue(
			findIndex(
				parseInt(
					window.location.pathname.split("/")[
						window.location.pathname.split("/").length - 1
					]
				),
				data
			)
		);
	}, [data]);

	return (
		data && (
			<Tabs
				orientation="vertical"
				variant="scrollable"
				value={value}
				aria-label="BackofficeApplications list"
				className={classes.tabs}
			>
				{data.map((data, idx) => {
					var makeModelText = data && data.objectMake + " " + data.objectModel;
					if (makeModelText.length >= 25) {
						makeModelText = makeModelText.substring(0, 25) + "...";
					}
					return (
						<Tab
							key={idx}
							icon={
								<Icon
									className={clsx(
										`fas fa-${data.objectIcon}`,
										classes.objectIcon
									)}
									color="primary"
									fontSize="large"
								/>
							}
							label={
								<>
									{data.objectMake ? (
										<>
											<Typography variant="body2">
												<FormattedMessage
													id="minside.backofficeApplicationList.make_model"
													defaultMessage="{makeModelText}"
													description="Label for object in BackofficeApplicationList"
													values={{ makeModelText: makeModelText }}
												/>
											</Typography>
											<Typography>
												<FormattedMessage
													id="minside.backofficeApplicationList.regNumber"
													defaultMessage="{regNumber}"
													description="Reg number label for object in BackofficeApplicationList"
													values={{
														...data,
														regNumber: data.regNumber
															? data.regNumber
															: "Mangler regnummer",
													}}
												/>
											</Typography>
										</>
									) : (
										<FormattedMessage
											id="minside.backofficeApplicationList.missing_object"
											defaultMessage="Ubestemt kjøretøy"
											description="Label for missing object in BackofficeApplicationList"
										/>
									)}
									<Typography variant="body2">
										<FormattedMessage
											id="minside.backofficeApplicationList.applicationNr"
											defaultMessage="Kontraktnr: {id}"
											description="Label for applicationnumber in BackofficeApplicationList"
											values={{ ...data }}
										/>
									</Typography>
								</>
							}
							{...changeToTabPanel(idx)}
							className={classes.tabItem}
							onClick={() => {
								closeMenuDrawer();
								navigate(`/backofficeapplication/${data.id}`);
							}}
						/>
					);
				})}
			</Tabs>
		)
	);
};

const changeToTabPanel = (index: number) => {
	return {
		id: `backofficeApplicationList-tab-${index}`,
		"aria-controls": `backofficeApplicationList-tabpanel-${index}`,
	};
};
